import { useState, useEffect, useCallback } from "react";
import usePrevious from './usePrevious';

function usePagination(data, limit) {
    const [currentPage, setCurrentPage] = useState(1);
    const pageCount = Math.ceil(data.length / limit);

    const currentData = () => {
        const begin = (currentPage - 1) * limit;
        const end = begin + limit;
        return data.slice(begin, end);
    };

    const setPage = useCallback((page) => {
        const pageNumber = Math.max(1, page);
        setCurrentPage(() => Math.min(pageNumber, pageCount));
    }, [pageCount]);

    const currentDataSet = currentData();

    useEffect(() => {
        if (data.length) {
            if (!currentDataSet.length) {
                if (currentPage > pageCount) {
                    setPage(currentPage - 1);
                }
            }
        }
    }, [currentDataSet.length, currentPage, data.length, pageCount, setPage]);

    const previousLimit = usePrevious(limit);

    useEffect(() => {
        if (previousLimit !== limit) {
            setCurrentPage(1);
        }
    }, [limit, previousLimit]);

    return {
        setPage,
        currentData,
        currentPage: currentPage - 1,
        pageCount
    };
}

export default usePagination;